import styled from '@emotion/styled';

export const TableCell = styled.div`
  display: table-cell;
  padding: 3px 0;
  &:not(:first-of-type) {
    text-align: center;
  }
`;
